export const SET_BREADSCRUMBS = 'SET_BREADSCRUMBS';
export const UPDATE_BREADSCRUMBS = 'UPDATE_BREADSCRUMBS';
export const RESET_BREADCRUMBS = 'RESET_BREADCRUMBS';